import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, TextField, Button, DialogActions, Typography, Box, InputAdornment, DialogContentText } from '@mui/material';
import { Backdrop, CircularProgress } from '@mui/material';

import { useAuth } from '../../../Auth/AuthContext';
import { getUniqueActiveCashbox } from '../../../utils/cashbox';
import { formatApiMoneyForInput, parseColombianMoneyInput } from '../../../utils/money';
import { getApiErrorMessage } from '../../../utils/apiErrorMessage';
import { sessionRequestConfig } from '../../../utils/csrf';

const API_URL = process.env.REACT_APP_API_URL;
const getId = (value) => (value && typeof value === 'object' ? value.id : value);
const mapIds = (values = []) => values.map(getId).filter(Boolean);

async function actualizarReporteDiario(valor) {
  const fecha = new Date();
  const hoy = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, "0")}-${String(fecha.getDate()).padStart(2, "0")}`;
  try {
      const response = await axios.get(`${API_URL}/reporte_diario/`);
      console.log(response)

      const reportes = await response.data, reporteHoy = reportes.find(r => r.fecha === hoy && r.tipo === "M-I");
      if (reporteHoy) {
          const nuevoValor = parseFloat(reporteHoy.valor) + Number(valor);
          console.log(parseFloat(reporteHoy.valor) + ' | ' + Number(valor))
          console.log(nuevoValor)
          const responsePut = await axios.put(`${API_URL}/reporte_diario/${reporteHoy.id}/`, { valor: nuevoValor } );
          console.log(responsePut)
      } else {
          await axios.post(`${API_URL}/reporte_diario/`, { fecha: hoy, tipo: "M-I", valor: Number(valor) });
      }
  } catch (error) {
      console.error("Error en la actualización del reporte:", error);
  }
}

export default function DialogCancelMensualidad({ data, handleUpdateData, handleCloseCancelDialog, openCancelDialog }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const submitRef = useRef(false);

  const [valor, setValor] = useState();
  const [error, setError] = useState("");

    useEffect(() => {
      const apiValue = !data.renovado
        ? (data.valorTicketModificado || data.valor)
        : data.valorTicketModificado;
      setValor(apiValue == null ? '' : formatApiMoneyForInput(apiValue));
    }, [data]);
  
  // Estados de errores por campo
  const [fieldErrors, setFieldErrors] = useState({
    valor: false,
  });

  const validateFields = () => {
    const errors = {
      valor: valor === null,
    };
    setFieldErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

  const handleSubmit = async () => {
    if (submitRef.current || loading) return;
    if (!validateFields()) {
      setError("Por favor, complete todos los campos.");
      return;
    }
    submitRef.current = true;
    setLoading(true);

    try {
    const cajaActual = await getUniqueActiveCashbox(API_URL, user);
    const canonicalValue = parseColombianMoneyInput(valor);
  
    // Crear el nuevo movimiento de caja
    const nuevoMovimiento = {
      tipo: "Ingreso",
      monto: canonicalValue,
      isME: 'mensualidad',
      observacion: `Mensualidad cancelada de: ${data.cliente.nombre} ${data.cliente.apellidos} Vehiculo: ${data.historial.tipo_vehiculo} ${data.historial.color} ${data.historial.placa}`
    };
  
    const hoy = new Date().toISOString();

    const updatedData = {
      fecha_inicio: data.fecha_inicio,
      fecha_final: data.fecha_final,
      historial: getId(data.historial),
      cliente: getId(data.cliente),
      usuario: getId(data.usuario),
      movimiento: getId(data.movimiento),
      cancelado: true,
      fecha_cancelacion: hoy,
      valor: canonicalValue,
      valorTicketModificado: data.valorTicketModificado,
      observaciones: data.observaciones,
      renovado: data.renovado,
      ticketsMensualidad: mapIds(data.ticketsMensualidad),
      ticketsRenovaciones: mapIds(data.ticketsRenovaciones),
      financial: {
        caja_id: cajaActual.id,
        movimiento: nuevoMovimiento,
      },
    };
    const renovacionesIds = mapIds(data.renovaciones);
    updatedData.renovaciones = renovacionesIds

      const response = await axios.put(
        `${API_URL}/mensualidades/${data.id}/`,
        updatedData,
        sessionRequestConfig()
      );
      if (response.status === 200) {
        await actualizarReporteDiario(canonicalValue);

        await handleUpdateData();
        handleCloseCancelDialog();
      } else {
        throw new Error("Error al actualizar los datos");
      }
    } catch (err) {
      console.log(err)
      setError(getApiErrorMessage(
        err,
        'No fue posible cancelar la mensualidad.',
        ['historial', 'cliente', 'movimiento', 'usuario', 'renovaciones']
      ));
    } finally {
      submitRef.current = false;
      setLoading(false);
    }
  };

  return (
   <Dialog open={openCancelDialog} onClose={handleCloseCancelDialog}>
    <Backdrop
      open={loading}
      style={{ zIndex: 9999, color: '#fff' }}
    >
        <CircularProgress color="inherit" />
    </Backdrop>
    <DialogTitle>Cancelar Mensualidad</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Estás a punto de cancelar esta mensualidad. Confirma la cantidad final antes de proceder.
      </DialogContentText>
      <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>VALOR:</Typography>
          <TextField
            autoFocus
            fullWidth
            value={valor}
            type='text'
            inputMode='decimal'
            inputProps={{ maxLength: 20 }}
            InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, maxLength: 10 }}
            sx={{ textTransform: 'uppercase' }}
            onChange={(e) => { setValor(e.target.value); setFieldErrors((prev) => ({ ...prev, valor: false })); }} // Resetear el error al cambiar el valor
            error={fieldErrors.valor} // Mostrar error si el campo está vacío
            helperText={fieldErrors.valor ? "Este campo es obligatorio" : ""} // Mensaje de error
          />
      </Box>
      {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseCancelDialog} color="error" variant="outlined">Cancelar</Button>
      <Button disabled={loading} onClick={handleSubmit} color='primary' variant="contained">Confirmar</Button>
    </DialogActions>
  </Dialog>
  );
}
